import { Component, OnDestroy, OnInit } from '@angular/core';
import { distinctUntilKeyChanged, Observable, Subscription, switchMap, take } from 'rxjs';
import { CmsComponentData, CurrentProductService } from '@spartacus/storefront';
import { ProductShortcutService } from './core/product-shortcut.service';
import { ProductShotcuts } from './core/product-shortcut.model';
import { Product, ProductScope, TranslationService, WindowRef } from '@spartacus/core';
import { ToasterService } from '../../../../components/toaster/toaster.service';
import { TOASTER_TYPE } from '../../../../components/toaster/toaster.model';

@Component({
  selector: 'product-shortcut-features',
  templateUrl: './product-shortcut-features.component.html',
  styleUrl: './product-shortcut-features.component.scss',
  standalone: false,
})
export class ProductShortcutFeaturesComponent implements OnInit, OnDestroy {
  productShortcuts$ = this.productShortcutService.getShorcut();
  product$: Observable<Product | null> = this.currentProductService.getProduct([
    ProductScope.DETAILS,
    ProductScope.PRICE,
  ]);
  subscription = new Subscription();

  constructor(
    private componentData: CmsComponentData<any>,
    private productShortcutService: ProductShortcutService,
    private currentProductService: CurrentProductService,
    private toasterService: ToasterService,
    private translationService: TranslationService,
    private winref: WindowRef,
  ) {}

  ngOnInit(): void {
    this.populateComponent();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  populateComponent() {
    this.subscription.add(
      this.componentData.data$
        .pipe(
          distinctUntilKeyChanged('shortcuts'),
          switchMap(data => this.productShortcutService.normalize(data)),
        )
        .subscribe(shortcuts => {
          this.productShortcutService.setShorcut(shortcuts);
        }),
    );
  }

  hasVisibleEntries(container: ProductShotcuts) {
    return container.shortcuts.filter(shortcut => shortcut.visible).length > 0;
  }

  scrollToSection(selector: string) {
    const $container = document.querySelector(selector) as HTMLDivElement;
    const isVisible = this.checkIfVisible($container);

    if ($container && isVisible) {
      if ($container.classList.contains('collapse-item') && !$container.classList.contains('is-open')) {
        const $action = $container.querySelector('.js-collapse-item-action') as HTMLDivElement;
        $action.click();
      }

      $container.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      this.translationService
        .translate('shortcuts.noContainer')
        .pipe(take(1))
        .subscribe(text => {
          this.toasterService.init({
            type: TOASTER_TYPE.INFO,
            content: text,
          });
        });
    }
  }

  checkIfVisible($container: HTMLElement): boolean {
    if (!this.winref.isBrowser()) {
      return false;
    }

    if (!$container) {
      return false;
    }

    const style = window.getComputedStyle($container);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') {
      return false;
    }

    return true;
  }
}
